var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("auto-modal-content", {
    attrs: { "is-showing": _vm.isShowingModal, settings: _vm.settings },
    on: { "should-close": _vm.onCloseModal },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/AutoModal.vue